import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11.049 18a1 1 0 0 0 1-1v-1a3 3 0 0 1 3-3V5H8.403a1 1 0 0 0-.929.629l-2.4 6A1 1 0 0 0 6.003 13h3.046a1 1 0 0 1 .949 1.316c-.456 1.367-.4 2.345-.155 2.915.214.5.598.769 1.206.769m0 2a3 3 0 0 0 3-3v-1a1 1 0 0 1 1-1h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H8.403a3 3 0 0 0-2.786 1.886l-2.4 6C2.43 12.856 3.881 15 6.003 15h1.76c-.196 1.127-.125 2.163.242 3.019C8.54 19.269 9.657 20 11.049 20m6-15v8h2V5z",
      clipRule: "evenodd"
    }
  )
);
var SvgThumbsDownOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ThumbsDownOutlined_default = SvgThumbsDownOutlined;

export { ThumbsDownOutlined_default as default };
